import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownloadAlt, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import {
  setEditClient,
  setEditMode,
} from '../../actions/advisor';
import s from './EditClientHeader.css';

library.add(faCloudDownloadAlt, faChevronLeft);

class EditClientHeader extends PureComponent {

  constructor(props) {
    super(props);
  }

  goBack() {
    this.props.setEditMode('');
    this.props.setEditClient(null);
  }

  render() {
    return (
      <div style={{marginBottom: '20px'}}>
        <div className="row">
          <div className="col-md-6">
            <div className={s.returnCol} onClick={() => this.goBack()}>
              <FontAwesomeIcon icon="chevron-left" size="2x" color="#05A9B1" className={s.headerIcon}/>
              &nbsp;&nbsp;<div className={s.addText}>All Clients</div>
            </div>
          </div>
          <div className="col-md-6" style={{textAlign:'right'}}>
            <div className={s.addCol} onClick={this.toggleAddClientForm}>
              <div className={s.addText}>Client Proposal</div>
              <FontAwesomeIcon icon="cloud-download-alt" size="2x" color="#05A9B1" className={s.headerIcon}/>
            </div>
            <div style={{paddingLeft:'40px'}} className={s.addCol} onClick={this.toggleAddClientForm}>
              <div className={s.addText}>Advisor Report</div>
              <FontAwesomeIcon icon="cloud-download-alt" size="2x" color="#05A9B1" className={s.headerIcon}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, {
  setEditClient,
  setEditMode,
})(EditClientHeader);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/EditClientHeader.js